// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox'


class EditProfile extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      customer:{
        "name": '',
        "customer_type": '',
        "date_of_birth": moment(),
        "gender": '',
        "email": '',
        "mobile_no": '',
        "jersey_size": '',
        "father_name": '',
        "father_number": '',
        "mother_name": '',
        "mother_number": '',
        "address": '',
        "school": '',
        "apartment": '',
        "level": '',

      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleSkill = this.handleSkill.bind(this);
  }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.customer);
    new_selected_one['date_of_birth'] = date
    this.setState({customer: new_selected_one});
  }

  componentDidMount() {
    this.getCustomerDetails();
    
  }
  
  getCustomerDetails(){
    const url = `${getLocationOrigin()}/customer_list/`+this.state.id+`/edit_customer/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ customer: data.customer}))
       .catch(error => error);

  }

  postEditedMatch(data, props) {
    console.log(data.date_of_birth);
    if(!data.date_of_birth){
      var date = undefined;
    }
    else{
      var date = moment(data.date_of_birth).format("YYYY-MM-DD");
    }
    if(data.customer_type == 'Adult'){
      var customer_type = 1;
    }
    else if(data.customer_type == 'Child'){
      var customer_type = 2;
    }
    else{}

    const url = `${getLocationOrigin()}/customer_list/`+this.state.id+`/edit_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'name': data.name,
                                        'mobile_no': data.mobile_no,
                                        'email': data.email,
                                        'date_of_birth': date,
                                        'gender': data.gender,
                                        'customer_type': customer_type,
                                        'father_name': data.father_name,
                                        'father_number': data.father_number,
                                        'mother_name': data.mother_name,
                                        'mother_number': data.mother_number,
                                        'jersey_size': data.jersey_size,
                                        'address': data.address,
                                        'school': data.school,
                                        'apartment':data.apartment,
                                        'level': data.level  });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleSkill(event){
    const name = event.target.name;
    var new_Skill = Object.assign({}, this.state.customer);
    new_Skill[name][0].game_level = event.target.value;
    this.setState({customer: new_Skill});
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.customer);
    new_selected_one[name] = event.target.value
    this.setState({customer: new_selected_one});

  }

  handleSubmit(event) {
    console.log(this.state.customer);
    event.preventDefault();
    this.postEditedMatch(this.state.customer, this.props);
  }

  render() {
    console.log("here");
    console.log(this.state.customer.customer_type);
    return(
      <div style={styles.container}>
        <div className="row col-md-10 table-bordered" style={styles.table}>
            
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Profile</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Name
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="name" className="form-control"
                  placeholder="Name " value={this.state.customer.name} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Mobile
              </div>
              <div className="col-md-6 input-group">
                <input type="tel" name="mobile_no" className="form-control" size="10"
                  placeholder="Mobile" value={this.state.customer.mobile_no} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Email
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="email" className="form-control"
                  placeholder="Email" value={this.state.customer.email} onChange={this.handleChange}/>
              </div>
            </div>
               <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Date of Birth
              </div>
              <DatePicker selected={this.state.customer.date_of_birth} onChange={this.handleStartDate}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Type
              </div>
              <select name="customer_type" className="col-md-6" style={styles.item_body} value={this.state.customer.customer_type}
                onChange={this.handleChange}> 
                  <option value="Adult">Adult</option>
                  <option value="Child">Child</option>
              }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Gender
              </div>
              <select name="gender" className="col-md-6" style={styles.item_body} value={this.state.customer.gender}
                onChange={this.handleChange}>
                  <option value="M">M</option>
                  <option value="F">F</option>
              }
              </select>
            </div>
           
           {
            (this.state.customer.customer_type != 'Adult') ?
            <div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Fathers Name
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="father_name" className="form-control"
                  placeholder="Name " value={this.state.customer.father_name} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Fathers No
              </div>
              <div className="col-md-6 input-group">
                <input type="tel" name="father_number" className="form-control"
                  placeholder="Name " value={this.state.customer.father_number} onChange={this.handleChange}/>
              </div>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Mother's Name
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="mother_name" className="form-control"
                  placeholder="Name " value={this.state.customer.mother_name} onChange={this.handleChange}/>
              </div>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Mother's No
              </div>
              <div className="col-md-6 input-group">
                <input type="tel" name="mother_number" className="form-control"
                  placeholder="Name " value={this.state.customer.mother_number} onChange={this.handleChange}/>
              </div>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                School
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="school" className="form-control"
                  placeholder="Name " value={this.state.customer.school} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Residential Address
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="address" className="form-control"
                  placeholder="Name " value={this.state.customer.address} onChange={this.handleChange}/>
              </div>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Gamelevel
              </div>
              <select name="level" className="col-md-6" style={styles.item_body}
                onChange={this.handleSkill}> 
                <option value>-------</option>
                  <option value="Beginner">Football Beginner</option>
                  <option value="Advanced">Football Advanced</option>
                  <option value="Elite">Football Elite</option>
              }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Apartment Name
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="apartment" className="form-control"
                  placeholder="Name " value={this.state.customer.apartment} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Jersey Size
              </div>
              <div className="col-md-6 input-group">
                <input type="tel" name="jersey_size" className="form-control"
                  placeholder="Name " value={this.state.customer.jersey_size} onChange={this.handleChange}/>
              </div>
            </div>

            </div>
            :
            <div>
             why here
            </div>
           }
           
            
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
         
         

        </div>
      </div>
    );
  }
}

export default EditProfile;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editProfile/index.js